import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderChefEvents extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices); 
  }

  getItemHtml(item, relatedMedia) {
    const { imageData, fileData } = super.setRelatedMedia(item, relatedMedia);   

    const html = `
        <div class="col-4">
          <div class="Card -h-scale">
            <img src="${imageData.Url}" class="-mb2" alt="Event thumbnail" />
            <div class="-mt0">
              <time class="h6 -fs12 -c-darkgrey">${this.getEventDate(item.EventStart)}</time>
              <h5 class="-mb3">${this.encodeHtml(item.Title)}</h5>
              <a href="/events/${item.UrlName}" target="_blank" class="HoverBox -mta -i-next">More info</a>
            </div>
          </div>
        </div>
    `;

    return html;

  }

  getEventDate(utcDate){
    let currentDate = new Date(utcDate);
    const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
    return monthNames[currentDate.getMonth()] + " " + currentDate.getDate() + this.nth(currentDate.getDate()) ;
  }

  nth(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    }
  }
}
